module.exports = "pegasus/assets/themelp1/small/bg0.png";